import React, { Component } from "react";
import styles from "./trips.module.scss";
import { withLogisticTripControlPoints } from "../../../shared/containers/containerLogisticTripControlPoints";
import LogisticAlatmTool from "../AlarmTools/LogisticAlatmTool";
import { states } from "../../../reducers/queriesStates";
import { withLogisticRoutes } from "../../../shared/containers/containerLogisticRoutes";
import { withLogisticTrips } from "../../../shared/containers/containerLogisticTrips";

class TripControlPointAlarm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorTitle: null,
    };
  }

  componentDidUpdate(preProps) {
    const { logisticUpdateTripControlPointAlarmDataState, errors, onGetLogisticTrip, tripId } = this.props;

    if (
      logisticUpdateTripControlPointAlarmDataState === states.FAILURE &&
      preProps.logisticUpdateTripControlPointAlarmDataState === states.REQUEST
    ) {
      const index = errors[0].data.indexOf("\n\r");

      const errorTile = errors[0].data.substring(0, index);
      this.setState({ errorTile });
    }

    if (
      logisticUpdateTripControlPointAlarmDataState === states.READY &&
      preProps.logisticUpdateTripControlPointAlarmDataState === states.REQUEST
    ) {
      onGetLogisticTrip({ id: tripId });
    }
  }

  onUpdateAlarm(alarm) {
    const { onUpdateLogisticControlPointAlarm, tripId, routeId, controlPoint } = this.props;

    this.setState({ errorTile: null });

    onUpdateLogisticControlPointAlarm({
      tripId,
      routeId,
      controlPointId: controlPoint.id,
      time: alarm.time,
      duration: alarm.duration,
      alarmActive: alarm.active,
    });
  }

  onCloseHandler() {
    const { onSetControlPointAlarm } = this.props;

    onSetControlPointAlarm(null, null);
  }

  render() {
    const { logisticUpdateTripControlPointAlarmDataState, controlPoint } = this.props;
    const { errorTile } = this.state;

    return (
      <div className={styles.tripControlPointAlarmContainer}>
        <LogisticAlatmTool
          key={controlPoint.id}
          title={`Контрольная точка "${controlPoint.title}"`}
          alarm={controlPoint.alarm}
          withDays={false}
          onUpdateAlarm={this.onUpdateAlarm.bind(this)}
          errorTile={errorTile}
          isRequest={logisticUpdateTripControlPointAlarmDataState === states.REQUEST}
          onClose={this.onCloseHandler.bind(this)}
        />
      </div>
    );
  }
}

export default withLogisticTrips(withLogisticTripControlPoints(React.memo(TripControlPointAlarm)));
